import React from "react";
import moment from "moment";

const MilestoneTooltipContent = props => {
  return (
    <div className="tooltipDefaultContainer position-relative text-white">
      <p className="tooltipDefaultContainerParagraph tooltipTaksName mb-2">
        {props.task.name}
      </p>

      {props.task.type === "originalScheduled" && (
        <>
          <p className="tooltipDefaultContainerParagraph tooltipDefaultContent mb-2">
            {`Original Start Date: ${moment(props.task.start).format(
              "DD MMM YYYY"
            )}`}
          </p>

          <p className="tooltipDefaultContainerParagraph tooltipDefaultContent mb-1">
            {`Original End Date: ${moment(props.task.end).format(
              "DD MMM YYYY"
            )}`}
          </p>
        </>
      )}

      {props.task.type === "revisedScheduled" && (
        <>
          <p className="tooltipDefaultContainerParagraph tooltipDefaultContent mb-2">
            {`Revised/Actual Start Date: ${moment(props.task.start).format(
              "DD MMM YYYY"
            )}`}
          </p>

          <p className="tooltipDefaultContainerParagraph tooltipDefaultContent mb-1">
            {`Revised/Actual End Date: ${moment(props.task.end).format(
              "DD MMM YYYY"
            )}`}
          </p>
        </>
      )}

      {props.task.delayInDays !== null &&
        props.task.type === "revisedScheduled" && (
          <div className="projectDelayContainer d-flex align-items-center">
            <span className="delay-icon d-flex justify-content-center mr-1" />
            <p className="projectDelay mb-0">
              {`Delay: ${props.task.delayInDays} Days`}
            </p>
          </div>
        )}
    </div>
  );
};

export default MilestoneTooltipContent;
